import React from 'react'
import { EDealType } from '@unfoldrtech/portal-mic'

import { CurrentGlobalDealTypeText } from '../../../Global/fonts/CurrentGlobalDealTypeText'

export const TableDataCellCampaignType = ({
  dataValue,
}: {
  dataValue: EDealType
}) => {
  return <CurrentGlobalDealTypeText dealType={dataValue} />
}
